import type {
  CSSProperties,
  FC,
  InputHTMLAttributes,
  ReactNode,
  RefObject,
  SelectHTMLAttributes,
} from "react";

export interface TTableFuncFetchDataParameters {
  pagination?: ITableStatePagination;
  params?: any;
  isForceUpdate?: boolean;
}

export type TTableFuncFetchData = (
  options?: TTableFuncFetchDataParameters
) => Promise<any>;

export interface ITableStructureItem {
  name: string;
  key?: string;
  render?: (
    rowValue: any,
    fetchData: (params?: TTableFuncFetchDataParameters) => void,
    column: ITableStructureItem
  ) => any;
  style?: CSSProperties;
  className?: string;
  sort?: ITableStructureSort;
  searchBox?: TableSearchBoxType;
}

export interface ITableStructureSort {
  key?: string;
  increaseValue?: any;
  descreaseValue?: any;
}

export interface ITableFilterStructureItem {
  name: string;
  key: string;
  defaultValue?: any;
  renderValue?: (value: any) => string;
  input: FC<ITableFilterInputProps>;
}

export interface ITableFilterInputProps {
  paramKey: string;
  params: any;
  value: any;
  onChange: (value: any) => void;
}

export interface ITableResponse {
  count: number;
  data: any[];
}

export interface ITableFilterProps {
  structure: ITableFilterStructureItem[];
  type?: "popup" | "panel";
}

export interface ITableProps {
  structure: ITableStructureItem[];
  onFetchData: (params: ITableParams) => Promise<ITableResponse>;
  filter?: ITableFilterProps;
  className?: string;
  itemPerPages?: number;
  enableReinitialize?: boolean;
  id?: string;
  searchBox?: ITableSearchProps;
  ref?: RefObject<ITableRef>;
  onRowClick?: (value: any) => void;
  isHeaderActive?: boolean;
  tableSearchBox?: boolean;
  filters?: any;
  onFilters?: (data: any, filters: any) => any;
}

export type TableSearchBoxType =
  | TableSearchBoxSelect
  | InputHTMLAttributes<HTMLInputElement>;

export type TableSearchBoxSelect = SelectHTMLAttributes<HTMLSelectElement> & {
  type: "select";
  select: {
    loading?: boolean;
    options: any[];
    getItemValue: (item: any) => string | number;
    getItemLabel: (item: any) => ReactNode;
  };
};

export interface ITableSearchBoxProps {
  structure: ITableStructureItem[];
  onSubmit: TTableFuncFetchData;
}

export interface ITableStatePagination {
  pageNumber: number;
  itemsPerPage: number;
}

export interface ITableParams {
  limit: number;
  offset: number;
  pageNumber: number;
  [name: string]: any;
}

export interface ITableState {
  isFetchingData: boolean;
  count: number;
  data: any[];
  error: string;
  params: any;
  pagination: ITableStatePagination;
}

export interface ITableScrollProps {
  structure: ITableStructureItem[];
  filters?: ITableFilterStructureItem[];
  isScrollInside?: boolean;
  className?: string;
  itemPerPages?: number;
  onFetchData: (params: ITableParams) => Promise<ITableResponse>;
  searchBox?: ITableSearchProps;
}

export interface TableSearchOnFetchDataResponse {
  label: string;
  value: any;
}

export interface ITableSearchProps {
  onFetchData: (q: string) => Promise<any[]>;
  onSelect: (value: any) => void;
  placeholder?: string;
}

export enum ETableSortDefaultValue {
  INCREASE = "INCREASE",
  DESCREASE = "DESCREASE",
}

export interface ITableRef {
  fetchData: TTableFuncFetchData;
  state: ITableState;
}
